import { getPlanOfCareLocatorItemsBySignatureIdOptions, type PlanOfCareReviewViewModel } from '@generated';
import { Section } from '~/shared/section/Section';
import { SectionHeader } from '~/shared/section/SectionHeader';
import { useSuspenseQuery } from '@tanstack/react-query';
import { PlanOfCareLocatorItems } from '~/features/careplanning/planofcare/PlanOfCareLocatorItems';

export function LocatorItemsTab({ review }: { review: PlanOfCareReviewViewModel }) {
	const { data: planOfCareLocatorItems } = useSuspenseQuery(getPlanOfCareLocatorItemsBySignatureIdOptions(review.signature.id));

	if (planOfCareLocatorItems.items.length === 0) {
		return null;
	}

	return (
		<Section>
			<SectionHeader
				title="Locator Items"
				sectionButtonProps={
					planOfCareLocatorItems.items.filter(x => !x.resolved).length === 0 ? { onClick: () => console.log('edit') } : undefined
				}
			/>
			<PlanOfCareLocatorItems planOfCareLocatorItems={planOfCareLocatorItems.items} />
		</Section>
	);
}
